<template>
  <div id="preview">
    <v-alert v-show="true" color="primary" value="true" outline>
      {{ $t('previewAlert') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>. {{ $t('previewAlert2') }} 
    </v-alert>   
    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <!-- Formulaire -->
    <div v-else>

      <!-- widghet 2022 -->
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-expansion-panel>
            <v-expansion-panel-content>
              <div slot="header">
                <v-icon class="mr-2 primary--text">color_lens</v-icon>
                {{ $t('previewPerson') }}
              </div>
              <v-card class="ml-3">
              <v-expansion-panel>
                <!-- Couleurs -->
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_couleurs')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">color_lens</v-icon>
                    {{ $tc('colors', 2, {count: ''}) | cap }}
                    <code>{{ color.text }}</code>
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-container grid-list-xl>
                        <v-layout row>
                          <v-flex class="xs12">
                            <v-select
                              dense
                              v-model="color"
                              :label="$t('colorShemes') | cap"
                              :items="colors2019"
                              return-object
                              @input="updateColors2019()"
                              box
                              menu-props="auto"
                            >
                              <template slot="selection" slot-scope="data">
                                <v-list-tile-action>
                                  <v-icon left :style="'color: #' + data.item.colors[0] + '!important'">color_lens</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <div v-text="data.item.text"></div>
                                </v-list-tile-content>
                              </template>
                              <template slot="item" slot-scope="data">
                                <v-list-tile-action>
                                  <v-icon left :style="'color: #' + data.item.colors[0] + '!important'">color_lens</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <div v-text="data.item.text"></div>
                                </v-list-tile-content>
                              </template>
                            </v-select>
                          </v-flex>
                        </v-layout>
                        
                        <v-layout row wrap>
                          <v-flex class="xs12 sm6" v-for="i in 4" :key="i"
                            @click="idxPicker = i - 1"
                          >
                            <v-menu
                              lazy
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              :nudge-bottom="-20"
                              max-width="225px"
                            >
                            
                              <v-text-field
                                v-model="options.DSK_COLORS[i - 1]"
                                :label="colorsLabel[i - 1] | cap"
                                readonly
                                prefix="#"
                                slot="activator"
                                box
                                :hint="colorsHint[i - 1] | cap"
                                persistent-hint
                              >
                                <v-icon
                                  slot="append"
                                  :style="'color : #' + options.DSK_COLORS[i - 1] + ';'"
                                >style</v-icon>
                              </v-text-field>
                              <chrome-picker
                                :value="options.DSK_COLORS[i - 1]"
                                @input="updateFromPicker"
                              ></chrome-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                
                <!-- Dimensions -->
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_dimensions')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">transform</v-icon>
                    {{ $t('sizes') | cap }}
                    <code>{{ options.DSK_WIDTH }}px x {{ options.DSK_HEIGHT }}px</code>
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-slider
                        v-model="options.DSK_WIDTH"
                        :min="300"
                        :max="1500"
                        thumb-label="always"
                        :label="$t('width') | cap"
                      >
                        <v-icon slot="prepend" @click="options.DSK_WIDTH--">
                          remove_circle_outline
                        </v-icon>
                        <v-icon slot="append" @click="options.DSK_WIDTH++">
                          add_circle_outlines
                        </v-icon>
                      </v-slider>
                      <v-slider
                        v-model="options.DSK_HEIGHT"
                        :min="350"
                        :max="800"
                        thumb-label="always"
                        :label="$t('height') | cap"
                      >
                        <v-icon slot="prepend" @click="options.DSK_HEIGHT--">
                          remove_circle_outline
                        </v-icon>
                        <v-icon slot="append" @click="options.DSK_HEIGHT++">
                          add_circle_outlines
                        </v-icon>
                      </v-slider>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                
                <!-- Radius -->
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_coins')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">rounded_corner</v-icon>
                    {{ $t('previewArronfi') }}
                    <code>{{ radius }}px</code>
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-slider
                        v-model="radius"
                        :min="0"
                        :max="12"
                        thumb-label="always"
                        :label="$t('settArondi')"
                      >
                        <v-icon slot="prepend" @click="radius--">
                          remove_circle_outline
                        </v-icon>
                        <v-icon slot="append" @click="radius++">
                          add_circle_outlines
                        </v-icon>
                      </v-slider>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-card>
            </v-expansion-panel-content>

            <v-expansion-panel-content expand>
              <div slot="header">
                <v-icon class="mr-2 primary--text">view_compact</v-icon>
                {{ $t('previewPositio') }}
              </div>
              <v-card class="ml-3">
              <v-expansion-panel>
                <!-- Positionnement -->
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_position')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">view_compact</v-icon>
                    {{ $t("position") | cap }} Desktop
                    <code>{{ position }}</code>
                  </div>
                  <v-card>
                    <v-subheader class="ml-3">{{ $t('previewPlacer') }} {{ position }}</v-subheader>
                    <v-card-text class="mt-5" style="max-width: 300px;">
                      <v-layout row justify-space-between mb-4>
                        <v-flex xs1>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE == 'LEFT'}" class="rotate ml-0" small light @click="options.DSK_TAB_SIDE = 'LEFT'"></v-btn>
                        </v-flex>
                        <v-flex xs2>
                        </v-flex>
                        <v-flex xs1 ml-0>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE == 'RIGHT'}" class="rotate mb-0" small light @click="options.DSK_TAB_SIDE = 'RIGHT'"></v-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout row justify-space-between>
                        <v-flex xs2>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE == 'BOTTOM' && options.DSK_TAB_POS == '0'}" class="ml-4" small light @click="options.DSK_TAB_SIDE = 'BOTTOM'; options.DSK_TAB_POS = '0'"></v-btn>
                        </v-flex>
                        <v-flex xs2>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE == 'BOTTOM' && options.DSK_TAB_POS == '50'}" class="ml-3" small light @click="options.DSK_TAB_SIDE = 'BOTTOM'; options.DSK_TAB_POS = '50'"></v-btn>
                        </v-flex>
                        <v-flex xs2>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE == 'BOTTOM' && options.DSK_TAB_POS == '100'}"  small light @click="options.DSK_TAB_SIDE = 'BOTTOM'; options.DSK_TAB_POS = '100'"></v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <!-- Positionnement Mobile (état mini uniquement) -->
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_mobile_position')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">view_compact</v-icon>
                    {{ $t('previewPositioMobil') }}
                    <code>{{ positionMobile }}</code>
                  </div>
                  <v-card>
                    <v-subheader class="ml-3">{{ $t('previewPlacer') }} {{ positionMobile }}</v-subheader>
                    <v-card-text class="mt-5" style="max-width: 300px;">
                      <!--
                      <v-layout row justify-space-between mb-4>
                        <v-flex xs1>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE_MOBILE == 'LEFT'}" class="rotate ml-0" small light @click="options.DSK_TAB_SIDE_MOBILE = 'LEFT'"></v-btn>
                        </v-flex>
                        <v-flex xs2>
                        </v-flex>
                        <v-flex xs1 ml-0>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE_MOBILE == 'RIGHT'}" class="rotate mb-0" small light @click="options.DSK_TAB_SIDE_MOBILE = 'RIGHT'"></v-btn>
                        </v-flex>
                      </v-layout>
                      -->
                      <v-layout row justify-space-between>
                        <v-flex xs2>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE_MOBILE == 'BOTTOM' && options.DSK_TAB_POS_MOBILE == '0'}" class="ml-4" small light @click="options.DSK_TAB_SIDE_MOBILE = 'BOTTOM'; options.DSK_TAB_POS_MOBILE = '0'"></v-btn>
                        </v-flex>
                        <v-flex xs2>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE_MOBILE == 'BOTTOM' && options.DSK_TAB_POS_MOBILE == '50'}" class="ml-3" small light @click="options.DSK_TAB_SIDE_MOBILE = 'BOTTOM'; options.DSK_TAB_POS_MOBILE = '50'"></v-btn>
                        </v-flex>
                        <v-flex xs2>
                          <v-btn :class="{primary : options.DSK_TAB_SIDE_MOBILE == 'BOTTOM' && options.DSK_TAB_POS_MOBILE == '100'}" small light @click="options.DSK_TAB_SIDE_MOBILE = 'BOTTOM'; options.DSK_TAB_POS_MOBILE = '100'"></v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-card>
            </v-expansion-panel-content>    

            <!-- État du widget par défaut -->
            <v-expansion-panel-content>
              <div slot="header">
                <v-icon class="mr-2 primary--text">wb_iridescent</v-icon>
                {{ $t('previewRetract') }}
              </div>
              <v-card class="ml-3">
              <v-expansion-panel>
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_desk')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">wb_iridescent</v-icon>
                    {{ $t("defaultAppearance") | cap }} desktop
                    <code>{{ options.DSK_WIDGETSTATE === '3' ? $t('mini') : $t('middle') }}</code>
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-radio-group
                        v-model="options.DSK_WIDGETSTATE"
                        row
                        :hint="$t('labelWidgetState')"
                        persistent-hint
                      >
                        <v-radio color="primary" :label="$t('mini') | cap" value="3"></v-radio>
                        <v-radio color="primary" :label="$t('middle') | cap" value="2"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <!-- État du widget par défaut (Mobile) -->
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_mobile_desk')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">wb_iridescent</v-icon>
                    {{ $t("defaultAppearance") | cap }} mobile
                    <code>{{ options.DSK_WIDGETSTATE_MOBILE === '3' ? $t('mini') : $t('middle') }}</code>
                    
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-radio-group
                        v-model="options.DSK_WIDGETSTATE_MOBILE"
                        row
                        :hint="$t('labelWidgetState')"
                        persistent-hint
                      >
                        <v-radio color="primary" :label="$t('mini') | cap" value="3"></v-radio>
                        <v-radio color="primary" :label="$t('middle') | cap" value="2"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <!-- Cacher l'état moyen -->
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_hide_moyen')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">visibility_off</v-icon>
                      {{ $t('previewCacher') }} 
                    <code>{{ options.DSK_HIDE_MIDDLE_STATE ? $t('yes') : $t('no') }}</code>
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-switch
                        v-model="options.DSK_HIDE_MIDDLE_STATE"
                        label="Cacher l'état moyen"
                        color="primary"
                        hint="Compatible avec 'Apparence par défaut': 'Moyen'. En effet le widget pourra être en 'Moyen' par défaut, au début de la session du visiteur."
                        persistent-hint
                      ></v-switch>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <!-- Image de l'état moyen (agent) -->
                <v-expansion-panel-content @click.native="loadImg(true)"
                  :disabled="testBrideStatus('parametre_apercu_conseiller')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">photo</v-icon>
                    {{ $t('previewAvatarChat') }} 
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-container grid-list-sm fluid>
                        <v-layout row wrap v-if="imagesAgent.length">
                          <v-flex
                            v-for="(img, i) in imagesAgent"
                            :key="i"
                            xs2
                            d-flex
                          >
                            <v-hover>
                              <v-card
                                flat
                                tile
                                class="d-flex picto"
                                @click="updateImg(true, img, i)"
                                style="cursor: pointer;"
                                slot-scope="{ hover }"
                                :class="`elevation-${hover ? 6 : 0}`"
                                :id="'picto_' + i"
                              >
                                <v-img :src="img">
                                  <v-layout
                                    slot="placeholder"
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-layout>
                                </v-img>
                              </v-card>
                            </v-hover>
                          </v-flex>
                        </v-layout>
                        <v-progress-circular
                          v-else
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <!-- Image de l'état moyen (bot) -->
                <v-expansion-panel-content @click.native="loadImg(false)"
                  :disabled="testBrideStatus('parametre_apercu_bot')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">photo</v-icon>
                    {{ $t('previewAvatarBot') }} 
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-container grid-list-sm fluid>
                        <v-layout row wrap v-if="imagesBot.length">
                          <v-flex
                            v-for="(img, i) in imagesBot"
                            :key="i"
                            xs2
                            d-flex
                          >
                            <v-hover>
                              <v-card
                                flat
                                tile
                                class="d-flex picto"
                                @click="updateImg(false, img, i)"
                                style="cursor: pointer;"
                                slot-scope="{ hover }"
                                :class="`elevation-${hover ? 6 : 0}`"
                                :id="'picto_' + i"
                              >
                                <v-img :src="img">
                                  <v-layout
                                    slot="placeholder"
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-layout>
                                </v-img>
                              </v-card>
                            </v-hover>
                          </v-flex>
                        </v-layout>
                        <v-progress-circular
                          v-else
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-card>
            </v-expansion-panel-content> 

          <!-- Mode Side On -->
            <v-expansion-panel-content
              :disabled="testBrideStatus('parametre_apercu_sideon')"
            >
              <div slot="header">
                <v-icon class="mr-2 primary--text">chrome_reader_mode</v-icon>
                {{ $t('previewDeploy') }}
                <v-tooltip bottom 
                  @click.native.stop="openDialog(
                    {
                      title: $t('titleInfoSideOn'),
                      content: $t('contentInfoSideOn')
                    }
                  )"
                >
                  <template slot="activator">
                    <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
                  </template>
                  <span>{{$t('enSavoirPlus')}}</span>
                </v-tooltip>
              </div>
              <v-card class="ml-3">

                <v-card-text v-if="checkPermission('NO_PEONS_NO_AGENTS_NO_ADMINS_NO_SUPER')">
                  <v-switch
                    v-model="options.DSK_SIDEON"
                    label="Side On (Desktop uniquement)"
                    color="primary"
                    :hint="$t('sideoneDesciption')"
                    persistent-hint
                  ></v-switch>
                  <v-switch
                    v-model="options.DSK_SIDEHOVER"
                    label="Side hover (Desktop uniquement)"
                    color="primary"
                    :hint="$t('sideoneDescription2')"
                    persistent-hint
                  ></v-switch>
                </v-card-text>

                <!-- Afficher liste d'agents -->
                <v-expansion-panel>
                  <v-expansion-panel-content
                    :disabled="testBrideStatus('parametre_apercu_hide_liste')"
                  >
                    <div slot="header">
                      <v-icon class="mr-2 primary--text">people</v-icon>
                      {{ $t("showAgentList") | cap }}
                      <code>{{ options.DSK_HIDE_AGENT_LIST ? $t("yes") : $t("no") }}</code>
                    </div>
                    <v-card>
                      <v-card-text>
                        <v-switch v-model="options.DSK_HIDE_AGENT_LIST" :label="$t('showAgentList')" color="primary"></v-switch>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-card>
            </v-expansion-panel-content>

          <!-- Langue et Textes du front-->
            <v-expansion-panel-content>
              <div slot="header">
                <v-icon class="mr-2 primary--text">text_fields</v-icon>
                {{ $t('settContenu') }}
              </div>
              <v-card class="ml-3">
              <v-expansion-panel>
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_lang')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">translate</v-icon>
                    {{ $t('previewLang') }}
                    <code>{{ options.DSK_GETELANG === '' ? $t("defaut") : options.DSK_GETELANG}}</code>
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-select
                        dense
                        v-model="options.DSK_GETELANG"
                        :items="langsFront"
                        :label="$t('language')"
                        prepend-icon="translate"
                      ></v-select>
                      <small>{{ $t("defautFrontlanguage") | cap }}</small>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_title_close')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">title</v-icon>
                    {{ $t("widgetTitle") | cap }}
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-text-field v-for="(l, i) in langs" :key="i" v-model="options.DSK_TAB_MSG_JSON[l.value]" :label="l.text"></v-text-field> 
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_title_offline')"
                   @click.native.stop="agenttOnline()"
                >

                  <div slot="header">
                    <v-icon class="mr-2 primary--text">title</v-icon>
                    {{ $t("widgetSubTitleOffline") | cap }}
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-text-field v-for="(l, i) in langs" :key="i" v-model="options.DSK_TAB_MSG_JSON2[l.value]" :label="l.text"></v-text-field> 
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_apercu_title_online')"
                  @click.native.stop="agenttOffline()"
                >

                  <div slot="header">
                    <v-icon class="mr-2 primary--text">title</v-icon>
                    {{ $t("widgetSubTitleOnline") | cap }}
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-text-field v-for="(l, i) in langs" :key="i" v-model="options.DSK_TAB_MSG_JSON3[l.value]" :label="l.text"></v-text-field> 
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-card>
            </v-expansion-panel-content>

            <!-- Ancienne section Display -->
            <v-expansion-panel-content>
              <div slot="header">
                <v-icon class="mr-2 primary--text">settings_applications</v-icon>
                {{ $t('previewRestrict') }}
                <v-tooltip bottom 
                  @click.native.stop="openDialog(
                    {
                      title: $t('previewAfficher'),
                      content: $t('previewRestricDesc')
                    }
                  )"
                >
                  <template slot="activator">
                    <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
                  </template>
                  <span>{{$t('enSavoirPlus')}}</span>
                </v-tooltip>
              </div>
              <v-card class="ml-3">
              <v-expansion-panel>              
                <!-- Horaires -->
                <v-expansion-panel-content @click.native="loadImg(false)"
                  :disabled="testBrideStatus('parametre_affichage_horaire')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">schedule</v-icon>
                    {{ $t("displayTimes") | cap }}
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-layout>
                        <v-flex xs12 sm12 md6>
                          <!-- Horaires d'affichage -->
                          <v-radio-group v-model="form.hours" :hint="$t('defineWidgetHours')" persistent-hint>
                            <v-radio :label="$t('allTheTime') | cap" color="primary" value="all"></v-radio>
                            <v-radio :label="$t('customHours')  | cap" color="primary" value="defined"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- Définition des horaires -->
                      <v-layout v-if="form.hours == 'defined'" row wrap>
                        <v-flex xs12>
                          <v-btn flat class="primary--text" @click="openHours()">{{ $t('timesSeveralDays') }}<v-icon right>event</v-icon></v-btn>
                        </v-flex>
                        <v-expansion-panel>
                          <v-expansion-panel-content v-for="day in form.days" :key="day.name">
                            <v-layout align-center row spacer slot="header">
                              <v-flex xs12>
                                <span class="hidden-md-and-up">{{ day.name.substring(0, 3) }}. : </span>
                                <span class="hidden-sm-and-down">{{ day.name }} : </span>
                                <span v-if="day.am.active || day.pm.active">
                                  <span v-if="day.am.active"> {{ $t('from') }}<code>{{ day.am.start }}</code> {{ $t('to') }} <code>{{ day.am.end }}</code></span>
                                  <span v-if="day.am.active && day.pm.active"> {{ $t('and') }}</span>
                                  <span v-if="day.pm.active">{{ $t('from') }} <code>{{ day.pm.start }}</code> {{ $t('to') }} <code>{{ day.pm.end }}</code></span>
                                </span>
                                <span v-else>
                                  <span>{{ $t("disabledToday") | cap }}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                            <v-card class="grey lighten-3">
                              <v-card-text>
                                <v-layout row wrap>
                                  <v-flex xs12 sm6 md2>
                                    <!-- Activer le matin -->
                                    <v-switch 
                                      :label="$t('activateMorning') | cap " 
                                      v-model="day.am.active"
                                      light
                                      color="primary"
                                    ></v-switch>
                                  </v-flex>
                                  <v-flex xs12 sm6 md2>
                                    <!-- Temps Matin -->
                                    <v-text-field 
                                      slot="activator"
                                      :label="$t('from') + ` ${ day.name } ` + $t('morning')"
                                      v-model="day.am.start"
                                      prepend-icon="access_time"
                                      :disabled="!day.am.active"
                                      readonly
                                      @click="openTimePicker(day, 'am', 'start')"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field 
                                      slot="activator"
                                      :label="$t('to') + ` ${ day.name } ` + $t('morning')"
                                      v-model="day.am.end"
                                      prepend-icon="access_time"
                                      :disabled="!day.am.active"
                                      readonly
                                      @click="openTimePicker(day, 'am', 'end')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                  <v-flex xs12 sm6 md2>
                                    <!-- Activer l'après-midi -->
                                    <v-switch 
                                      :label="$t('activateAfternoon') | cap " 
                                      v-model="day.pm.active"
                                      light
                                      color="primary"
                                    ></v-switch>
                                  </v-flex>
                                  <!-- Temps Après-midi -->
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field 
                                      slot="activator"
                                      :label="$t('from') + ` ${ day.name } ` + $t('afternoon')"
                                      v-model="day.pm.start"
                                      prepend-icon="access_time"
                                      :disabled="!day.pm.active"
                                      readonly
                                      @click="openTimePicker(day, 'pm', 'start')"
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6 md2>
                                    <v-text-field 
                                      slot="activator"
                                      :label="$t('to') + ` ${ day.name } ` + $t('afternoon')"
                                      v-model="day.pm.end"
                                      prepend-icon="access_time"
                                      :disabled="!day.pm.active"
                                      readonly
                                      @click="openTimePicker(day, 'pm', 'end')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content
                  :disabled="testBrideStatus('parametre_affichage_url')">
                  <div slot="header"><v-icon class="mr-2 primary--text">language</v-icon>{{ $t('urlDisplay') | cap }}</div>
                  <v-card class="mb-3">
                    <v-card-text>
                      <v-layout>
                        <v-flex xs12>
                          <!-- White ou Black List -->
                          <v-radio-group v-model="form.urls" :hint="$t('chooseWhiteOrBlack')" persistent-hint>
                            <v-radio :label="$t('everywhere') | cap " color="primary" value="all"></v-radio>
                            <v-radio label="White List" color="primary" value="showOnOff"></v-radio>
                            <v-radio label="Black List" color="primary" value="hideOnOff"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap v-show="form.urls != 'all'">
                        <v-flex xs12>
                          <v-card>
                            <v-card-text>
                              <!-- <v-tooltip left> -->
                                <v-fab-transition slot="activator">
                                  <v-btn
                                    v-show="form.urls != 'all'"
                                    class="secondary"
                                    dark
                                    absolute
                                    top
                                    right
                                    fab
                                    @click.stop="openRule()"
                                  >
                                    <v-icon>add</v-icon>
                                  </v-btn>
                                </v-fab-transition>
                                <!-- <span>ajouter une règle d'affichage</span> -->
                              <!-- </v-tooltip> -->
                              <v-data-table
                                :headers="headersRules"
                                :items="form.rules"
                                :no-data-text="$t('noRules')"
                                hide-actions
                              >
                                <template slot="items" slot-scope="props">
                                  <td v-if="props.item.list === form.urls">
                                    <v-edit-dialog
                                      :return-value.sync="props.item.type"
                                      :cancel-text="$t('cancel')"
                                      :save-text="$t('submit')"
                                      large
                                    >
                                      <div>{{ props.item.type.text }}</div>
                                      <div slot="input" class="mt-3 title">{{ $t('changeType') }}</div>
                                      <v-select
                                        slot="input"
                                        :items="typeRules"
                                        v-model="props.item.type"
                                        return-object
                                        autofocus
                                      ></v-select>
                                    </v-edit-dialog>
                                  </td>
                                  <td v-if="props.item.list === form.urls">
                                    <v-edit-dialog
                                      :cancel-text="$t('cancel')"
                                      :save-text="$t('submit')"
                                      :return-value.sync="props.item.content"
                                      large
                                      lazy
                                    >
                                      <div><code>{{ props.item.content }}</code></div>
                                      <div slot="input" class="mt-3 title">{{ $t('editContent') }}</div>
                                      <v-text-field
                                        slot="input"
                                        label="Modification"
                                        v-model="props.item.content"
                                        single-line
                                        counter
                                        autofocus
                                      ></v-text-field>
                                    </v-edit-dialog>
                                  </td>
                                  <td v-if="props.item.list === form.urls" class="text-xs-right">
                                    <v-btn icon flat @click.stop="deleteRule(props.index)">
                                      <v-icon>delete</v-icon>
                                    </v-btn>
                                  </td>
                                </template>
                              </v-data-table>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-card>
            </v-expansion-panel-content>

            <!-- Ancienne section Display NIVEAU 2-->
            <v-expansion-panel-content>
              <div slot="header">
                <v-icon class="mr-2 primary--text">settings_applications</v-icon>
                {{ $t('previewCondition') }}
                <v-tooltip bottom 
                  @click.native.stop="openDialog(
                    {
                      title: $t('previewCondAdd'),
                      content: $t('previewConDesk')
                    }
                  )"
                >
                  <template slot="activator">
                    <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
                  </template>
                  <span>{{$t('enSavoirPlus')}}</span>
                </v-tooltip>
              </div>
              <v-card class="ml-3">
              <v-expansion-panel>
                <v-expansion-panel-content @click.native="loadImg(true)"
                  :disabled="testBrideStatus('parametre_affichage_perso')"
                >
                  <div slot="header">
                    <v-icon class="mr-2 primary--text">settings_applications</v-icon>
                    {{ $t("customHours") | cap }}
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <!-- Masquer sur mobile -->
                          <v-switch 
                            :label="$t('hideOnMobile') | cap" 
                            v-model="form.hiddenMobile"
                            light
                            color="primary"
                          ></v-switch>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs12 md6>
                          <!-- Affichage par défaut -->
                          <v-select 
                            :items="optsDisplayDefault" 
                            v-model="form.displayDefault"
                            :label="$t('defaultView') | cap" 
                            return-object
                          ></v-select>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs12 md6>
                          <!-- Compteur (uniquement si l'option est un délai) -->
                          <v-layout row v-if="form.displayDefault.value == 'default_timeout'">
                            <v-flex xs8>
                              <v-slider 
                                v-model="form.timeout"
                                thumb-label
                                :min="0"
                                :max="300"
                              ></v-slider>
                            </v-flex>
                            <v-flex xs4>
                              <v-subheader>{{ form.timeout }} sec.</v-subheader>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-card>
            </v-expansion-panel-content>
            
          </v-expansion-panel>
        </v-flex>

        <!-- WIDGET SVG (PARTIE DROITE)-->
        <v-flex xs12 md6>
          <v-tabs
            v-model="activeState2019"
            fixed-tabs
            centered
            class="elevation-1"
            slider-color="secondary"
            color="primary"
            dark
          >
            <v-tab>{{ $t('big') | cap }}</v-tab>
            <v-tab>{{ $t('middle') | cap }}</v-tab>
            <v-tab>{{ $t('mini') | cap }}</v-tab>
          </v-tabs>
          <v-tabs
            v-if="activeState2019 == 1"
            v-model="botOrConseiller"
            centered
            class="elevation-0"
            color="transparent"
          >
            <v-tab>{{ $t('conseiller') | cap }}</v-tab>
            <v-tab>bot</v-tab>
          </v-tabs>
          
          <v-card height="550px">
            <iframe
              width="100%"
              height="550"
              :src="iframeInnerSrc2019"
              frameborder="0"
            ></iframe>
          </v-card>
          <!-- Validation du formulaire -->
          <div class="text-xs-right">
            <v-btn
              color="primary"
              flat
              dark
              :block="$vuetify.breakpoint.xsOnly"
              @click.native="resetOptions()"
            >{{ $t('cancel') }}<v-icon class="primary--text" right>settings_backup_restore</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              :block="$vuetify.breakpoint.xsOnly"
              :loading="loadingPost"
              @click.native="postOptions()"
            >{{ $t('save') }}<v-icon dark right>save</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>

    </div>

    <!-- dialog Infos -->
    <wz-dialog-infos
      @fermeDialog="fermeDialogInfos"
      :titleDialog="titleDialog"
      :contentDialog="contentDialog"
    >
    </wz-dialog-infos>

    <!-- Time picker -->
    <v-dialog persistent v-model="showTp" lazy max-width="290">
      <v-time-picker 
        v-model="daySelected[amOrPm][startOrEnd]"
        actions
        scrollable
        format="24hr"
        :max="allowed.hours.max"
        :min="allowed.hours.min"
        color="primary"
      >
        <v-spacer></v-spacer>
        <v-btn flat @click="showTp = false; daySelected[amOrPm][startOrEnd] = tmpHours">{{ $t('cancel') | cap }}</v-btn>
        <v-btn flat color="primary" @click="showTp = false">{{ $t('submit') | cap }}</v-btn>
      </v-time-picker>
    </v-dialog>

    <!-- Appliquer les horaires d'une journée -->
    <v-dialog v-model="showHours" scrollable persistent width="350px">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('applySchedules') | cap }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px;">
          <v-select
            :items="days"
            v-model="dayHours"
            :label="$t('applyHours')" 
            return-object
          ></v-select>
          <v-data-table
            :headers="headersDays"
            :items="days"
            v-model="daysTmp"
            item-key="text"
            select-all="primary"
            class="elevation-1"
            hide-actions
            :total-items="7"
          >
            <template slot="headerCell" slot-scope="props">
              <span class="subheading">{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  class="primary--text"
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.text }}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showHours = false">{{ $t('cancel') }}</v-btn>
          <v-btn :disabled="!daysTmp.length" color="primary" flat @click="submitHours()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGUE Création règle-->
    <v-dialog v-model="showDialogRule" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t("createRule") | cap }}</v-card-title>
        <v-card-text>
          <form>
            <v-select
              v-model="ruleTmp.type"
              :items="typeRules"
              :label="$t('ruleType')"  
              return-object
              required
              v-validate="'required'" 
              data-vv-name="select"
              :error="wzErrors.has('select')"
              :error-messages="wzErrors.collect('select')"
            ></v-select>
            <v-text-field
              autofocus
              v-model="ruleTmp.content"
              :label="$t('ruleContent')" 
              required
              v-validate="'required'" 
              data-vv-name="ruleContentInput"
              :error="wzErrors.has('ruleContentInput')"
              :error-messages="wzErrors.collect('ruleContentInput')"
              @keyup.native.enter="submitRule()"
            ></v-text-field>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showDialogRule = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :disabled="wzErrors.any()" flat @click="submitRule()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { Chrome } from 'vue-color'
import { DOMAINE, CLOUD, HOTESSES_DIR, LEVEL } from '../../constants'
export default {
  components: {
    'chrome-picker': Chrome
  },

  data () {
    return {
      titleDialog: '',
      contentDialog: '',
      dialogProgress: false,
      options: {},
      saveOptions: {}, // options que l'on peut retrouver en annulant
      loadingGet: false,
      loadingPost: false,
      imgLoading: false, // indique si l'image est en train de se charger
      langs: [
        { text: _.upperFirst(this.$t('french')), value: 'FR' },
        { text: _.upperFirst(this.$t('english')), value: 'EN' },
        { text: _.upperFirst(this.$t('spanish')), value: 'ES' },
        { text: _.upperFirst(this.$t('german')), value: 'DE' },
        { text: _.upperFirst(this.$t('italian')), value: 'IT' },
        { text: _.upperFirst(this.$t('portuguese')), value: 'PT' }
      ],
      colorsLabel: [
        this.$t('primaryColor'),
        this.$t('secondaryColor'),
        this.$t('backgroundColor'),
        this.$t('iconsColor')
      ],
      colorsHint: [
        `Entête, scrollbar, boutons CTA (callback/meeting), widget mini`,
        `Sous-titre widget moyen`,
        `Bulles visiteurs`,
        `Textes visiteur, Nom et poste conseiller`
      ],
      activeState2019: null, // indique quel état du widget est actif
      botOrConseiller: null, // indique si c'est un bot ou conseiller
      radius: 0,
      imagesAgent: [],
      imagesBot: [],
      lastImg: '',
      imageBot: '',
      imageConseiller: '',
      widget2019: true,
      widgetOpen: true, // indique si le widget est ouvert
      widgetOnline: true, // indique si le widget est en mode connecté
      color: {},
      colorsDefault: [
        {
          text: 'Magenta',
          value: 'black',
          colors: ['E3328B', '781A49', 'E3328B', 'FF57A5', '5E1037', 'FFFFFF']
        },
        {
          text: 'Bleu',
          value: 'blue',
          colors: ['90D1E5', '518898', 'BAEFFF', '62A4B8', '518898', '518898']
        },
        {
          text: 'Bleu 2',
          value: 'blue2',
          colors: ['91BAEB', '52759E', '91BAEB', '74A6E0', '52759E', '52759E']
        },
        {
          text: 'Vert',
          value: 'green',
          colors: ['8FBC5C', '517A2D', '8FBC5C', '3A5720', '223313', '3A5720']
        },
        {
          text: 'Orange',
          value: 'orange',
          colors: ['FFC091', 'ED790E', 'FFC091', 'B86627', '80471B', '80471B']
        },
        {
          text: 'Rouge',
          value: 'red',
          colors: ['D62834', '890D15', 'D62834', 'FF4956', '890D15', 'FFFFFF']
        },
        // {
        //   text: 'Turquoise',
        //   value: 'turquoise',
        //   colors: ['AFE8EA', '669C9D', 'D8FEFF', 'EAC6AF', '9D7256', '669C9D']
        // },
        {
          text: 'Menthe',
          value: 'menthe',
          colors: ['1ABC9C', '16A085', '1ABC9C', '0F6E5C', '16A085', '0F6E5C']
        },
        {
          text: 'Ardoise',
          value: 'ardoise',
          colors: ['34495E', '2C3E50', '2C3E50', '5B80A6', '2C3E50', 'FFFFFF']
        },
        {
          text: 'Violet',
          value: 'violet',
          colors: ['9B59B6', '8E44AD', '8E44AD', 'D164FF', '8E44AD', 'FFFFFF']
        },
        {
          text: 'Violet2',
          value: 'violet2',
          colors: ['7646C1', '532F8C', '532F8C', 'FFFFFF', 'FFFFFF', 'FFFFFF']
        },
        {
          text: 'Tournesol',
          value: 'tournesol',
          colors: ['F1C40F', 'F39C12', 'FFAC29', 'A62F03', '591202', '591202']
        },
        {
          text: 'Emeraude',
          value: 'emerode',
          colors: ['2ECC71', '27AE60', '27AE60', '33E67F', '27AE60', '124F2C']
        },
        {
          text: 'Carotte',
          value: 'carotte',
          colors: ['E67E22', 'D35400', 'E67E22', 'ED9D13', 'E67E22', '421A00']
        },
        {
          text: 'Brique',
          value: 'brique',
          colors: ['E74C3C', 'C0392B', 'C0392B', 'A7BD18', '758511', '691F17']
        },
        {
          text: 'Sable',
          value: 'sable',
          colors: ['F0DEB4', 'D5C295', 'D5C295', 'FFE8B2', 'D5C295', '665D47']
        },
        {
          text: 'Raisin',
          value: 'raisin',
          colors: ['3A6F81', '356272', '356272', '213D47', '0D181C', '6BC5E6']
        },
        {
          text: 'Pastèque',
          value: 'pasteque',
          colors: ['EF717A', 'D95459', 'EF717A', '619956', '4F7D46', 'FFFFFF']
        },
        {
          text: 'Pin',
          value: 'pin',
          colors: ['345F41', '2D5036', '345F41', '71C988', '2D5036', 'FFFFFF']
        },
        {
          text: 'Café',
          value: 'cafe',
          colors: ['5E4534', '503B2C', '5E4534', '9E7557', '5E4534', 'FFFFFF']
        },
        {
          text: 'Bonbons',
          value: 'bonbons',
          colors: ['F47CC3', 'D45C9E', 'F47CC3', 'FFB0D5', 'D45C9E', 'FFFFFF']
        },
        {
          text: 'Salade',
          value: 'salade',
          colors: ['A5C63B', '8EB021', 'A5C63B', '6A8026', '3E4A16', 'FFFFFF']
        },
        {
          text: 'Caramel',
          value: 'caramel',
          colors: ['A38671', '8E725E', 'A38671', '5C493C', '3B2F27', 'FFFFFF']
        },
        {
          text: 'Noir',
          value: 'noir',
          colors: ['2B2B2B', '262626', '2B2B2B', 'BFBABA', '2B2B2B', 'FFFFFF']
        },
        {
          text: 'Tricolore',
          value: 'tricolore',
          colors: ['007CFF', '0467CC', 'DA1818', 'FFFFFF', 'FFFFFF', 'FFFFFF']
        }
        // {
        //   text: 'Blanc',
        //   value: 'blanc',
        //   colors: ['ECF0F1', 'BDC3C7', 'ECF0F1', '6E6E6E', '4D4D4D', '4D4D4D']
        // }
      ],
      idxPicker: 0,
      // DISPLAY
      form: {
        // options d'affichage
        hiddenMobile: false,
        displayDefault: {},
        timeout: 0,

        // horaires d'affichage
        hours: '',
        days: [
          {
            name: this.$t('monday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('tuesday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('wednesday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('thursday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('friday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('saturday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('sunday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          }
        ],

        // URLs d'affichage
        urls: '',
        rules: []

      },

      // options du formulaire
      optsDisplayDefault: [],

      // time pickers
      showTp: false,
      daySelected: {},
      tmpHours: null,
      amOrPm: 'am',
      startOrEnd: 'start',
      allowed: { hours: { min: '0:00', max: '12:00' } },

      // dialog appliquer les horaires
      showHours: false,
      daysTmp: [],
      dayHours: null,
      days: [
        { text: _.upperFirst(this.$t('monday')), value: 0 },
        { text: _.upperFirst(this.$t('tuesday')), value: 1 },
        { text: _.upperFirst(this.$t('wednesday')), value: 2 },
        { text: _.upperFirst(this.$t('thursday')), value: 3 },
        { text: _.upperFirst(this.$t('friday')), value: 4 },
        { text: _.upperFirst(this.$t('saturday')), value: 5 },
        { text: _.upperFirst(this.$t('sunday')), value: 6 }
      ],

      // URLs d'affichage
      tmp: '',
      headersRules: [
        { text: _.upperFirst(this.$t('type')), align: 'left', sortable: false, value: 'type' },
        { text: _.upperFirst(this.$t('content')), align: 'left', sortable: false, value: 'content' },
        { text: '', align: 'left', sortable: false, value: 'actions' }
      ],
      typeRules: [
        { text: _.upperFirst(this.$t('fullUrl')), value: 'DSK_SHOW_URL' },
        { text: _.upperFirst(this.$t('containedUrl')), value: 'DSK_SHOW_PART_URL' },
        { text: _.upperFirst(this.$t('keyWords')), value: 'DSK_SHOW_TAGS' },
        { text: _.upperFirst(this.$t('classOrId')), value: 'DSK_SHOW_CLASS_ID' }
      ],
      showDialogRule: false,
      ruleTmp: {content: '', type: {}},
      random: Math.random() // random afin de forcer le reload des images persos
    }
  },
  mounted () {
    // cache si bride inactif
    if (this.testBrideStatus('parametre_affichage_perso_cible')) {
      this.optsDisplayDefault = [
        { text: this.$t('normal'), value: 'none' },
        { text: this.$t('afterDelay'), value: 'default_timeout' },
        { text: this.$t('ifOneAgentOnline'), value: 'default_agents' },
        { text: this.$t('onAgentIntervention'), value: 'default_open_agents' }
      ]
    } else {
      this.optsDisplayDefault = [
        { text: this.$t('normal'), value: 'none' },
        { text: this.$t('afterDelay'), value: 'default_timeout' },
        { text: this.$t('ifOneAgentOnline'), value: 'default_agents' },
        { text: this.$t('onAgentIntervention'), value: 'default_open_agents' },
        { text: this.$t('onTrackedVisitor'), value: 'open_if_alert' }
      ]
    }

    // console.log('this.$store.state._User.ongoingTuto', this.$store.state._User.ongoingTuto)
    // if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
    //   this.openDialogProgress()
    // }
    if (this.$store.state._User.lang === 'en') {
      this.langs = [
        { text: _.upperFirst(this.$t('english')), value: 'EN' },
        { text: _.upperFirst(this.$t('french')), value: 'FR' },
        { text: _.upperFirst(this.$t('spanish')), value: 'ES' },
        { text: _.upperFirst(this.$t('german')), value: 'DE' },
        { text: _.upperFirst(this.$t('italian')), value: 'IT' },
        { text: _.upperFirst(this.$t('portuguese')), value: 'PT' }
      ]
    } else if (this.$store.state._User.lang === 'es') {
      this.langs = [
        { text: _.upperFirst(this.$t('spanish')), value: 'ES' },
        { text: _.upperFirst(this.$t('english')), value: 'EN' },
        { text: _.upperFirst(this.$t('french')), value: 'FR' },
        { text: _.upperFirst(this.$t('german')), value: 'DE' },
        { text: _.upperFirst(this.$t('italian')), value: 'IT' },
        { text: _.upperFirst(this.$t('portuguese')), value: 'PT' }
      ]
    }
  },
  created () {
    // Pas de paramètres d'affichage en fonction d'un temps donné
    // s'il s'agit d'une licence Eezy Chat
    if (this.$store.getters['_User/level'].rights === LEVEL.CHAT) {
      this.optsDisplayDefault.splice(1, 1)
    }
    this.getOptions()
    this.daySelected = this.form.days[0]
    this.dayHours = { text: this.form.days[0].name, value: 0 }
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_preview'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_preview'
        }
      }, 800);
    }
    /* eslint-enable */
  },
  methods: {
    // ---------------------------
    // etat du widget avec des agents en ligne
    agenttOnline () {
      // console.log('widgetOnline')
      this.widgetOnline = true
    },
    // ---------------------------
    // etat du widget avec des agents hors ligne
    agenttOffline () {
      // console.log('widgetOnline')
      this.widgetOnline = false
    },
    // ---------------------------
    // open dialog Infos
    openDialog (data) {
      this.titleDialog = data.title
      this.contentDialog = data.content
    },
    // ---------------------------
    // close dialog Infos
    fermeDialogInfos () {
      this.titleDialog = ''
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    },
    getOptions () {
      this.loadingGet = true
      this.form.rules = []
      this.axios.get('get/settings_preview.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID)
      .then(res => {
        this.options = res.data
        this.options.DSK_COLORS = this.options.DSK_COLORS.split('|')
        this.options.DSK_HIDE_AGENT_LIST = (this.options.DSK_HIDE_AGENT_LIST === '0')
        this.options.DSK_ONGLET_RADIUS = this.options.DSK_ONGLET_RADIUS.split('|')
        this.radius = this.options.DSK_ONGLET_RADIUS[0]
        try {
          this.options.DSK_TAB_MSG_JSON = JSON.parse(this.options.DSK_TAB_MSG_JSON) || {}
          this.options.DSK_TAB_MSG_JSON2 = JSON.parse(this.options.DSK_TAB_MSG_JSON2) || {}
          this.options.DSK_TAB_MSG_JSON3 = JSON.parse(this.options.DSK_TAB_MSG_JSON3) || {}
        } catch (error) {}

        this.options.DSK_CALLBACK_ONOFF = (this.options.DSK_CALLBACK_ONOFF === '1')
        this.options.DSK_ACTIVE_PERSO_FO = (this.options.DSK_ACTIVE_PERSO_FO === '1')
        this.options.DSK_PERSO_FO_ONLINE = (this.options.DSK_PERSO_FO_ONLINE === '1')
        this.options.DSK_PERSO_FO_OFFLINE = (this.options.DSK_PERSO_FO_OFFLINE === '1')
        this.options.DSK_WIDGET_2019 = (this.options.DSK_WIDGET_2019 === '2022')
        this.widget2019 = this.options.DSK_WIDGET_2019
        this.options.DSK_SIDEON = (this.options.DSK_SIDEON === '1')
        this.options.DSK_SIDEHOVER = (this.options.DSK_SIDEHOVER === '1')
        this.options.DSK_HIDE_MIDDLE_STATE = (this.options.DSK_HIDE_MIDDLE_STATE === '1')

        this.lastImg = this.options.DSK_POULETTE
        this.imageConseiller = this.options.DSK_POULETTE
        this.imageBot = this.options.DSK_POULET
        if (this.options.DSK_POULET && this.options.DSK_POULET !== '' && this.options.DSK_POULET !== 'bot_empty') {
          this.lastImg = this.options.DSK_POULET
        }
        this.saveOptions = _.cloneDeep(this.options)

        // place l'apparence du widget selon le mode d'ouverture par défaut
        // this.widgetOpen = (this.options.DSK_OPTIONS_2 === 'default_open')
        this.widgetOpen = true
        // Sélectionne le jeu de couleur s'il n'est pas personnalisé
        this.findSetColors()

        // options affichage
        this.form.hiddenMobile = (this.options.DSK_HIDE_MOBILE === '1')
        this.form.displayDefault = _.clone(_.find(this.optsDisplayDefault, {'value': this.options.DSK_OPTIONS.split('|')[0]})) || {}
        this.form.timeout = this.options.DSK_OPTIONS.split('|')[1]
        // options horaires
        this.form.hours = this.options.DSK_SCHEDULES.split('|')[0]
        let hours = this.options.DSK_SCHEDULES.split('|')
        // lundi
        this.form.days[0].am.active = !_.isEmpty(hours[1] + hours[2] + hours[3] + hours[4]) && !_.isNil(hours[1]) && !_.isNil(hours[2]) && !_.isNil(hours[3]) && !_.isNil(hours[4])
        this.form.days[0].am.start = (this.form.days[0].am.active) ? hours[1] + ':' + hours[2] : '00:00'
        this.form.days[0].am.end = (this.form.days[0].am.active) ? hours[3] + ':' + hours[4] : '00:00'
        this.form.days[0].pm.active = !_.isEmpty(hours[5] + hours[6] + hours[7] + hours[8])
        this.form.days[0].pm.start = (this.form.days[0].pm.active) ? hours[5] + ':' + hours[6] : '12:00'
        this.form.days[0].pm.end = (this.form.days[0].pm.active) ? hours[7] + ':' + hours[8] : '12:00'
        // mardi
        this.form.days[1].am.active = !_.isEmpty(hours[9] + hours[10] + hours[11] + hours[12])
        this.form.days[1].am.start = (this.form.days[1].am.active) ? hours[9] + ':' + hours[10] : '00:00'
        this.form.days[1].am.end = (this.form.days[1].am.active) ? hours[11] + ':' + hours[12] : '00:00'
        this.form.days[1].pm.active = !_.isEmpty(hours[13] + hours[14] + hours[15] + hours[16])
        this.form.days[1].pm.start = (this.form.days[1].am.active) ? hours[13] + ':' + hours[14] : '12:00'
        this.form.days[1].pm.end = (this.form.days[1].am.active) ? hours[15] + ':' + hours[16] : '12:00'
        // mercredi
        this.form.days[2].am.active = !_.isEmpty(hours[17] + hours[18] + hours[19] + hours[20])
        this.form.days[2].am.start = (this.form.days[2].am.active) ? hours[17] + ':' + hours[18] : '00:00'
        this.form.days[2].am.end = (this.form.days[2].am.active) ? hours[19] + ':' + hours[20] : '00:00'
        this.form.days[2].pm.active = !_.isEmpty(hours[21] + hours[22] + hours[23] + hours[24])
        this.form.days[2].pm.start = (this.form.days[2].pm.active) ? hours[21] + ':' + hours[22] : '12:00'
        this.form.days[2].pm.end = (this.form.days[2].pm.active) ? hours[23] + ':' + hours[24] : '12:00'
        // jeudi
        this.form.days[3].am.active = !_.isEmpty(hours[25] + hours[26] + hours[27] + hours[28])
        this.form.days[3].am.start = (this.form.days[3].am.active) ? hours[25] + ':' + hours[26] : '00:00'
        this.form.days[3].am.end = (this.form.days[3].am.active) ? hours[27] + ':' + hours[28] : '00:00'
        this.form.days[3].pm.active = !_.isEmpty(hours[29] + hours[30] + hours[31] + hours[32])
        this.form.days[3].pm.start = (this.form.days[3].pm.active) ? hours[29] + ':' + hours[30] : '12:00'
        this.form.days[3].pm.end = (this.form.days[3].pm.active) ? hours[31] + ':' + hours[32] : '12:00'
        // vendredi
        this.form.days[4].am.active = !_.isEmpty(hours[33] + hours[34] + hours[35] + hours[36])
        this.form.days[4].am.start = (this.form.days[4].am.active) ? hours[33] + ':' + hours[34] : '00:00'
        this.form.days[4].am.end = (this.form.days[4].am.active) ? hours[35] + ':' + hours[36] : '00:00'
        this.form.days[4].pm.active = !_.isEmpty(hours[37] + hours[38] + hours[39] + hours[40])
        this.form.days[4].pm.start = (this.form.days[4].pm.active) ? hours[37] + ':' + hours[38] : '12:00'
        this.form.days[4].pm.end = (this.form.days[4].pm.active) ? hours[39] + ':' + hours[40] : '12:00'
        // samedi
        this.form.days[5].am.active = !_.isEmpty(hours[41] + hours[42] + hours[43] + hours[44])
        this.form.days[5].am.start = (this.form.days[5].am.active) ? hours[41] + ':' + hours[42] : '00:00'
        this.form.days[5].am.end = (this.form.days[5].am.active) ? hours[43] + ':' + hours[44] : '00:00'
        this.form.days[5].pm.active = !_.isEmpty(hours[45] + hours[46] + hours[47] + hours[48])
        this.form.days[5].pm.start = (this.form.days[5].pm.active) ? hours[45] + ':' + hours[46] : '12:00'
        this.form.days[5].pm.end = (this.form.days[5].pm.active) ? hours[47] + ':' + hours[48] : '12:00'
        // dimanche
        this.form.days[6].am.active = !_.isEmpty(hours[49] + hours[50] + hours[51] + hours[52])
        this.form.days[6].am.start = (this.form.days[6].am.active) ? hours[49] + ':' + hours[50] : '00:00'
        this.form.days[6].am.end = (this.form.days[6].am.active) ? hours[51] + ':' + hours[52] : '00:00'
        this.form.days[6].pm.active = !_.isEmpty(hours[53] + hours[54] + hours[55] + hours[56])
        this.form.days[6].pm.start = (this.form.days[6].pm.active) ? hours[53] + ':' + hours[54] : '12:00'
        this.form.days[6].pm.end = (this.form.days[6].pm.active) ? hours[55] + ':' + hours[56] : '12:00'

        // options URL
        this.form.urls = 'all'
        if (this.options.DSK_SHOW_ONOFF === '1') {
          this.form.urls = 'showOnOff'
        } else if (this.options.DSK_HIDE_ONOFF === '1') {
          this.form.urls = 'hideOnOff'
        }
        // urls white list
        _.each(this.options.DSK_SHOW_URL.split('|'), url => {
          if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[0]), 'list': 'showOnOff' })
        })
        _.each(this.options.DSK_SHOW_PART_URL.split('|'), url => {
          if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[1]), 'list': 'showOnOff' })
        })
        _.each(this.options.DSK_SHOW_TAGS.split('|'), url => {
          if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[2]), 'list': 'showOnOff' })
        })
        _.each(this.options.DSK_SHOW_CLASS_ID.split('|'), url => {
          if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[3]), 'list': 'showOnOff' })
        })
        // urls black list
        _.each(this.options.DSK_HIDE_URL.split('|'), url => {
          if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[0]), 'list': 'hideOnOff' })
        })
        _.each(this.options.DSK_HIDE_PART_URL.split('|'), url => {
          if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[1]), 'list': 'hideOnOff' })
        })
        _.each(this.options.DSK_HIDE_TAGS.split('|'), url => {
          if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[2]), 'list': 'hideOnOff' })
        })
        _.each(this.options.DSK_HIDE_CLASS_ID.split('|'), url => {
          if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[3]), 'list': 'hideOnOff' })
        })
      })
      .catch(_ => {
      })
      .then(_ => {
        this.loadingGet = false
      })
    },

    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
    },

    /**
     * Enregistre les options en BDD
     */
    postOptions () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)
      // si cette étape est encore dans le tableau
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_SETTINGS_PREVIEW')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_SETTINGS_PREVIEW'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID)
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY)
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      dataToPost.append('DSK_COLORS', this.colorsToString)
      dataToPost.append('DSK_ONGLET_RADIUS', Array(4).fill(this.radius).join('|'))
      dataToPost.append('DSK_WIDTH', this.options.DSK_WIDTH)
      dataToPost.append('DSK_HEIGHT', this.options.DSK_HEIGHT)
      dataToPost.append('DSK_TAB_SIDE', this.options.DSK_TAB_SIDE)
      dataToPost.append('DSK_TAB_POS', this.options.DSK_TAB_POS)
      dataToPost.append('DSK_TAB_SIDE_MOBILE', this.options.DSK_TAB_SIDE_MOBILE)
      dataToPost.append('DSK_TAB_POS_MOBILE', this.options.DSK_TAB_POS_MOBILE)
      dataToPost.append('DSK_OPTIONS_2', this.options.DSK_OPTIONS_2)
      dataToPost.append('DSK_HIDE_AGENT_LIST', this.options.DSK_HIDE_AGENT_LIST ? '0' : '1')
      dataToPost.append('DSK_TAB_MSG_JSON', JSON.stringify(this.options.DSK_TAB_MSG_JSON))
      dataToPost.append('DSK_TAB_MSG_JSON2', JSON.stringify(this.options.DSK_TAB_MSG_JSON2))
      dataToPost.append('DSK_TAB_MSG_JSON3', JSON.stringify(this.options.DSK_TAB_MSG_JSON3))
      dataToPost.append('DSK_ASK_GEOLOC_ONOFF', this.options.DSK_ASK_GEOLOC_ONOFF ? '1' : '0')
      dataToPost.append('DSK_GETELANG', this.options.DSK_GETELANG)
      dataToPost.append('DSK_ACTIVE_PERSO_FO', this.options.DSK_ACTIVE_PERSO_FO ? '1' : '0')
      dataToPost.append('DSK_PERSO_FO_ONLINE', this.options.DSK_PERSO_FO_ONLINE ? '1' : '0')
      dataToPost.append('DSK_PERSO_FO_OFFLINE', this.options.DSK_PERSO_FO_OFFLINE ? '1' : '0')
      dataToPost.append('DSK_POULETTE', this.options.DSK_POULETTE)
      dataToPost.append('DSK_POULET', this.options.DSK_POULET)
      dataToPost.append('DSK_WIDGET_2019', this.options.DSK_WIDGET_2019 ? '2022' : '1')
      dataToPost.append('DSK_SIDEON', this.options.DSK_SIDEON ? '1' : '0')
      dataToPost.append('DSK_SIDEHOVER', this.options.DSK_SIDEHOVER ? '1' : '0')
      dataToPost.append('DSK_WIDGETSTATE', this.options.DSK_WIDGETSTATE)
      dataToPost.append('DSK_WIDGETSTATE_MOBILE', this.options.DSK_WIDGETSTATE_MOBILE)
      dataToPost.append('DSK_HIDE_MIDDLE_STATE', this.options.DSK_HIDE_MIDDLE_STATE ? '1' : '0')

      // options affichage
      let hiddenMobile = this.form.hiddenMobile ? '1' : '0'
      dataToPost.append('DSK_HIDE_MOBILE', hiddenMobile)
      dataToPost.append('DSK_OPTIONS', this.form.displayDefault.value + '|' + this.form.timeout)

      // options horaires
      let hours = this.form.hours
      _.each(this.form.days, day => {
        hours += (day.am.active) // si Watcheezy actif le matin
        ? '|' + day.am.start.split(':')[0] + '|' + day.am.start.split(':')[1] + '|' + day.am.end.split(':')[0] + '|' + day.am.end.split(':')[1]
        : '||||'
        hours += (day.pm.active) // si Watcheezy actif l'aprem
        ? '|' + day.pm.start.split(':')[0] + '|' + day.pm.start.split(':')[1] + '|' + day.pm.end.split(':')[0] + '|' + day.pm.end.split(':')[1]
        : '||||'
      })
      dataToPost.append('DSK_SCHEDULES', hours)

      // options URLs
      dataToPost.append('DSK_SHOW_ONOFF', (this.form.urls === 'showOnOff') ? '1' : '0')
      dataToPost.append('DSK_HIDE_ONOFF', (this.form.urls === 'hideOnOff') ? '1' : '0')
      let url = {'showOnOff': '', hideOnOff: ''}
      let partUrl = {'showOnOff': '', hideOnOff: ''}
      let tags = {'showOnOff': '', hideOnOff: ''}
      let classId = {'showOnOff': '', hideOnOff: ''}
      _.each(this.form.rules, rule => {
        if (this.typeRules[0].value === rule.type.value) {
          url[rule.list] += rule.content + '|'
        } else if (this.typeRules[1].value === rule.type.value) {
          partUrl[rule.list] += rule.content + '|'
        } else if (this.typeRules[2].value === rule.type.value) {
          tags[rule.list] += rule.content + '|'
        } else if (this.typeRules[3].value === rule.type.value) {
          classId[rule.list] += rule.content + '|'
        }
      })

      dataToPost.append('DSK_SHOW_URL', url.showOnOff)
      dataToPost.append('DSK_SHOW_PART_URL', partUrl.showOnOff)
      dataToPost.append('DSK_SHOW_TAGS', tags.showOnOff)
      dataToPost.append('DSK_SHOW_CLASS_ID', classId.showOnOff)

      dataToPost.append('DSK_HIDE_URL', url.hideOnOff)
      dataToPost.append('DSK_HIDE_PART_URL', partUrl.hideOnOff)
      dataToPost.append('DSK_HIDE_TAGS', tags.hideOnOff)
      dataToPost.append('DSK_HIDE_CLASS_ID', classId.hideOnOff)

      this.loadingPost = true
      this.axios.post('post/settings_preview.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.saveOptions = _.cloneDeep(this.options)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(_ => {
        this.loadingPost = false
      })
    },

    resetOptions () {
      this.radius = this.saveOptions.DSK_ONGLET_RADIUS[0]
      this.options = _.cloneDeep(this.saveOptions)
      this.findSetColors()
    },

    /**
     * Sauve le fichier image qui personnalise
     * le widget
     * @param  {String} mode ['online' | 'offline'] indique dans quel cas afficher l'image
     */
    saveImg (mode, filename) {
      if (!filename) {
        return
      }
      this.imgLoading = true
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('url', filename)
      dataToPost.append('mode', mode)
      dataToPost.append('lic_key', this.$store.state._Sites.siteSelected.LIC_KEY)
      dataToPost.append('dsk_id', this.$store.state._Sites.siteSelected.LIC_DSK_ID)

      this.axios.post('put/perso_fo.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // le changement de l'image a été pris en compte
      .then(response => {
        this.random = Math.random()
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('changeImageSuccess'), context: 'success' })
      })
      .catch(_ => {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('changeImageFailed'), context: 'error' })
      })
      .then(_ => {
        this.imgLoading = false
      })
    },

    /**
     * Change les couleurs du formulaire selon le jeu de couleur choisi
     */
    updateColors () {
      let idxColor = _.findIndex(this.colors, {'value': this.color.value})
      this.options.DSK_COLORS = this.colors[idxColor].colors
    },

    /**
     * permet de retrouver le nom du jeu de couleurs
     * si ce ne sont pas des couleurs persos
     */
    findSetColors () {
      this.color = _.clone(this.colors[0])
      _.each(this.colorsDefault, color => {
        if (_.difference(color.colors, this.options.DSK_COLORS).length === 0) {
          this.color = _.clone(color)
        }
      })
    },

    /**
     * Méthode pour le picker de couleur
     * afin d'obtenir les couleurs en héxadécimale
     */
    updateFromPicker (value) {
      console.log('this.idxPicker', this.idxPicker)
      this.options.DSK_COLORS.splice(this.idxPicker, 1, value.hex.split('#')[1])
    },

    /**
     * Change les couleurs du formulaire selon le jeu de couleur choisi
     * pour le wigdet dans la version 2019
     */
    updateColors2019 () {
      let idxColor = _.findIndex(this.colors2019, {'value': this.color.value})
      this.options.DSK_COLORS = this.colors2019[idxColor].colors
    },

    loadImg (agent) {
      if (agent && this.imagesAgent.length > 0) return
      if (!agent && this.imagesBot.length > 0) return
      this.axios.get('get/imagesHotesses.php?agent=' + agent).then((res) => {
        if (agent) {
          // console.log('agent : ', res.data)
          this.imagesAgent = res.data.map(img => HOTESSES_DIR + img)
        } else {
          this.imagesBot = res.data.map(img => HOTESSES_DIR + img)
        }
      })
    },

    updateImg (agent, img, elt) {
      img = img.split('/').reverse()[0].split('.')[0]
      if (agent) {
        this.options.DSK_POULETTE = img
        this.imageConseiller = img
        this.botOrConseiller = 0
      } else {
        this.options.DSK_POULET = img
        this.imageBot = img
        this.botOrConseiller = 1
      }
      this.lastImg = img
      let allpicto = document.querySelectorAll('.picto')
      for (let j = 0; j < allpicto.length; j++) {
        allpicto[j].style.border = ''
      }
      document.getElementById('picto_' + elt).style.border = '1px solid black'
    },
    openTimePicker (day, amOrPm, startOrEnd) {
      this.showTp = true // ouverture du dialog
      this.daySelected = day
      this.amOrPm = amOrPm
      this.startOrEnd = startOrEnd
      this.tmpHours = this.daySelected[amOrPm][startOrEnd]
      // heures et minutes autorisées dans le time pîcker
      this.allowed.hours = amOrPm === 'am'
      ? { min: '0:00', max: '12:59' } // matin
      : { min: '12:00', max: '23:59' } // aprem
    },
    /**
     * Gestion de l'application d'horaires à plusieurs jours
     */
    openHours () {
      this.showHours = true
    },
    submitHours () {
      this.showHours = false
      // pour tous les jours sélectionnés
      // il faut changer leurs horaires
      // par ceux du jour sélectionné
      const daySelected = this.form.days.find(d => d.name === this.dayHours.text)
      this.daysTmp.forEach(day => {
        let d = this.form.days.find(d => d.name === day.text.toLowerCase())
        d.am = _.cloneDeep(daySelected.am)
        d.pm = _.cloneDeep(daySelected.pm)
      })
      this.daysTmp = []
    },

    /**
     * Gestion des urls
     */
    openRule () {
      this.showDialogRule = true
      this.ruleTmp = { content: '', type: this.typeRules[0], list: this.form.urls }
    },
    submitRule () {
      if (!_.isEmpty(this.ruleTmp.content)) {
        this.showDialogRule = false
        this.form.rules.push(_.clone(this.ruleTmp))
      } else {
        this.$validator.validateAll()
      }
    },
    deleteRule (index) {
      this.form.rules.splice(index, 1)
    }
  },

  computed: {
    /**
     * @return {String} la position du widget
     */
    position () {
      let pos = ''
      if (this.options.DSK_TAB_SIDE === 'LEFT') {
        pos = this.$t('onLeft')
      } else if (this.options.DSK_TAB_SIDE === 'RIGHT') {
        pos = this.$t('onRight')
      } else if (this.options.DSK_TAB_SIDE === 'BOTTOM' && this.options.DSK_TAB_POS === '0') {
        pos = this.$t('bottomLeft')
      } else if (this.options.DSK_TAB_SIDE === 'BOTTOM' && this.options.DSK_TAB_POS === '50') {
        pos = this.$t('bottomMiddle')
      } else if (this.options.DSK_TAB_SIDE === 'BOTTOM' && this.options.DSK_TAB_POS === '100') {
        pos = this.$t('bottomRight')
      }
      return pos
    },
    /**
     * @return {String} la position du widget sur mobile
     */
    positionMobile () {
      let pos = ''
      if (this.options.DSK_TAB_SIDE_MOBILE === 'LEFT') {
        pos = this.$t('onLeft')
      } else if (this.options.DSK_TAB_SIDE_MOBILE === 'RIGHT') {
        pos = this.$t('onRight')
      } else if (this.options.DSK_TAB_SIDE_MOBILE === 'BOTTOM' && this.options.DSK_TAB_POS_MOBILE === '0') {
        pos = this.$t('bottomLeft')
      } else if (this.options.DSK_TAB_SIDE_MOBILE === 'BOTTOM' && this.options.DSK_TAB_POS_MOBILE === '50') {
        pos = this.$t('bottomMiddle')
      } else if (this.options.DSK_TAB_SIDE_MOBILE === 'BOTTOM' && this.options.DSK_TAB_POS_MOBILE === '100') {
        pos = this.$t('bottomRight')
      }
      return pos
    },
    /**
     * Ajoute l'option des langues par défaut dans la liste des langues
     * @return {Array}
     */
    langsFront () {
      let langs = _.clone(this.langs)
      langs.splice(0, 0, { text: this.$t('defaultLanguage'), value: '' })
      return langs
    },
    /**
     * Ajoute la couleur personnalisé dans la liste des jeux de couleurs
     * @return {Array}
     */
    colors () {
      let colorsPerso = {
        text: this.$t('personnalise'),
        value: this.$t('custom'),
        colors: this.options.DSK_COLORS
      }
      let colors = _.clone(this.colorsDefault)
      colors.splice(0, 0, colorsPerso)
      return colors
    },
    /**
     * @return {String} URL de l'iframe représentant le widget ouvert
     */
    iframeInnerSrc () {
      return (process.env.NODE_ENV === 'development')
      ? `${DOMAINE}/dev/fo/incl/svg_fo_innerNewBO.php?${this.iframeParams}`
      : `${DOMAINE}/fo/incl/svg_fo_innerNewBO.php?${this.iframeParams}`
    },
    /**
     * @return {String} URL de l'iframe représentant le widget fermé
     */
    iframeOuterSrc () {
      return (process.env.NODE_ENV === 'development')
      ? `${DOMAINE}/dev/fo/incl/svg_fo_outerNewBO.php?${this.iframeParams}`
      : `${DOMAINE}/fo/incl/svg_fo_outerNewBO.php?${this.iframeParams}`
    },
    /**
     * @return {String} URL de l'iframe représentant le widget ouvert 2019
     */
    iframeInnerSrc2019 () {
      return (process.env.NODE_ENV === 'development')
      // ? `${DOMAINE}/dev/fo/incl/inner2019.php?${this.iframeParams}`
      ? `${DOMAINE}/public/config/preview.php?${this.iframeParams}`
      // : `${DOMAINE}/fo/incl/inner2019.php?${this.iframeParams}`
      : `${CLOUD}/config/preview.php?${this.iframeParams}`
    },
    /**
     * @return {String} paramètres des iframes
     */
    iframeParams () {
      const lang = this.options.DSK_GETELANG.length === 0
        ? this.$i18n.locale.toUpperCase()
        : this.options.DSK_GETELANG
      const titleMiddleState = this.options.DSK_TAB_MSG_JSON[lang]
      let titleMiddleState2 = this.options.DSK_TAB_MSG_JSON2[lang]
      let titleMiddleState3 = this.options.DSK_TAB_MSG_JSON3[lang]
      // affiche le bon text en fonction de l'etat du widget
      if (this.widgetOnline) {
        titleMiddleState3 = this.options.DSK_TAB_MSG_JSON2[lang]
      } else {
        titleMiddleState3 = this.options.DSK_TAB_MSG_JSON3[lang]
      }
      let middleImage
      if (this.botOrConseiller) {
        middleImage = this.imageBot
      } else {
        middleImage = this.imageConseiller
      }
      let params = `deskColors=${this.colorsToString}`
      params = `${params}&deskWidth=${this.options.DSK_WIDTH}`
      params += `&deskHeight=${this.options.DSK_HEIGHT}`
      params += `&deskOnline=${this.widgetOnline}`
      params += `&callbackOnOff=${this.options.DSK_CALLBACK_ONOFF}`
      params += `&deskOngletRadius=${Array(4).fill(this.radius).join('|')}`
      params += `&fullName=${this.$store.getters['_User/fullName']}`
      params += `&job=${this.$store.state._User.job}`
      params += `&avatarId=${this.$store.state._User.id}`
      params += `&side=${this.options.DSK_TAB_SIDE}`
      params += `&pos=${this.options.DSK_TAB_POS}`
      params += `&sideOn=${this.options.DSK_SIDEON}`
      params += `&sideHover=${this.options.DSK_SIDEHOVER}`
      params += `&state=${this.activeState2019 + 1}`
      params += `&bot=${this.botOrConseiller + 1}`
      params += `&hideAgents=${this.options.DSK_HIDE_AGENT_LIST}`
      params += `&hideMiddleState=${this.options.DSK_HIDE_MIDDLE_STATE}`
      params += `&lang=${this.options.DSK_GETELANG}`
      params += `&imgMiddleState=${middleImage}`
      params += `&titleMiddleState=${titleMiddleState}`
      params += `&titleMiddleState2=${titleMiddleState2}`
      params += `&titleMiddleState3=${titleMiddleState3}`
      // console.log('params', params)
      return params
    },
    /**
     * Retourne les couleurs sélectionnées
     * au format string séparées par '|'
     * @return {String}
     */
    colorsToString () {
      return this.options.DSK_COLORS.join('|')
    },

    /**
     * Indique si est affiché le widget SVG ou le mode perso
     */
    showIframeOuter () {
      if (!this.options.DSK_ACTIVE_PERSO_FO) {
        return true
      }
      if (this.widgetOnline && this.options.DSK_PERSO_FO_ONLINE) {
        return false
      }
      if (!this.widgetOnline && this.options.DSK_PERSO_FO_OFFLINE) {
        return false
      }
      return true
    },
    persoFoOnlineSrc () {
      return (process.env.NODE_ENV === 'development')
      ? `${DOMAINE}/dev/media/desk/online/${this.$store.state._Sites.siteSelected.LIC_KEY}.png?${this.random}`
      : `${DOMAINE}/media/desk/online/${this.$store.state._Sites.siteSelected.LIC_KEY}.png?${this.random}`
    },
    persoFoOfflineSrc () {
      return (process.env.NODE_ENV === 'development')
      ? `${DOMAINE}/dev/media/desk/offline/${this.$store.state._Sites.siteSelected.LIC_KEY}.png?${this.random}`
      : `${DOMAINE}/media/desk/offline/${this.$store.state._Sites.siteSelected.LIC_KEY}.png?${this.random}`
    },

    colors2019 () {
      return this.colors.map(c => ({
        text: c.text,
        value: c.value,
        colors: [...c.colors.slice(0, 3), 'FFFFFF', ...c.colors.slice(4)]
      }))
    },
    headersDays () {
      return !this.daysTmp.length
      ? [{text: this.$t('allDays'), align: 'left', sortable: false}]
      : [{text: this.$t('noDays'), align: 'left', sortable: false}]
    },
    resizewidget2022 () {
      if (this.options.DSK_WIDGET_2019) {
        this.options.DSK_WIDTH = 400
        this.options.DSK_HEIGHT = 700
      }
    }

    // nextTuto () {
    //   this.$router.push({ path: '/settings/absence' })
    //   return false
    // },
    // quitTuto () {
    //   // this.installProgress = false
    //   // this.$store.state._User.ongoingTuto = false
    //   this.$store.commit('_User/ONGOING_TUTO', {
    //     ongoingTuto: false
    //   })
    //   this.$store.commit('_User/QUIT_TUTO', {
    //     tutoQuited: true
    //   })
    // }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      if (v) {
        this.getOptions()
      }
    }
    /**
     * Si perso du chat alors dialog indiquant si le callback actif
     */
    // 'options.DSK_ACTIVE_PERSO_FO': function (v) {
    //   if (v && this.options.DSK_CALLBACK_ONOFF) {
    //     this.options.DSK_ACTIVE_PERSO_FO = false
    //     this.$store.dispatch('_Notifier/NEW_NOTIF', {
    //       message: this.$t('disactivingCallback') + `'` + this.$store.state._Sites.siteSelected.LIC_URL + `'`,
    //       context: 'warning'
    //     })
    //   } else if (!v) {
    //     this.options.DSK_PERSO_FO_ONLINE = false
    //     this.options.DSK_PERSO_FO_OFFLINE = false
    //   }
    // }
  }
}
</script>

<style>
  .rotate {
    transform: rotate(90deg);
  }

  /**
   * Styles pour le pseudo HTML 
   * représentant l'agent et son avatar dans le widget
   */
  .widget-latin--open {
    position: absolute;
    width: 257px;
    margin-left: 25px;
    margin-top: 21px;
    display: flex;
  }
  .widget-latin--open__agent {
    margin-left: 5px;
    margin-top: 3px;
  }
  .widget-latin--open__agent-job {
    font-style: italic;
  }

  .widget-latin--close {
    position: absolute;
    width: 300px;
    margin-left: 65px;
    margin-top: 15px;
  }
  .widget-latin--close.rotate {
    margin-top: 217px;
    margin-left: -102px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/Preview.vue